/**
 * Product URL helpers for PDP and collection fallbacks.
 */

import { formatDisplayTitle } from './formatProductTitle';

export function productGroupKey(p) {
  return String(p.subcategory || p.type || 'all').trim() || 'all';
}

export function productDetailPath(p) {
  const cat = String(p.category || '').trim();
  const id = String(p.id || '').trim();
  if (!cat || !id) return '/shop';
  return `/product/${encodeURIComponent(cat)}/${encodeURIComponent(id)}`;
}

/** Category hub (sub-group tiles), e.g. /shop/rakhi. */
export function shopCategoryHubPath(categorySlug) {
  const cat = String(categorySlug || '').trim();
  if (!cat) return '/shop';
  return `/shop/${encodeURIComponent(cat)}`;
}

/** Sub-group list URL for a product's type/subcategory. */
export function shopGroupPath(categorySlug, groupKey) {
  const cat = String(categorySlug || '').trim();
  const g = String(groupKey || 'all').trim() || 'all';
  if (!cat) return '/shop';
  return `/shop/${encodeURIComponent(cat)}/${encodeURIComponent(g)}`;
}

/** All products in a category (hub "View all" + mega-menu). */
export function shopCategoryAllPath(categorySlug) {
  const cat = String(categorySlug || '').trim();
  if (!cat) return '/shop';
  return `/shop/${encodeURIComponent(cat)}/all`;
}

/** Human label for a shop group slug (subcategory / type). */
export function productGroupLabel(categoryMeta, groupKey, categorySlug = '') {
  const g = String(groupKey || '').trim();
  if (!g || g === 'all') {
    return formatDisplayTitle(categoryMeta?.name || categorySlug.replace(/-/g, ' ') || 'Collection');
  }
  const fromSub = (categoryMeta?.subcategories || []).find((s) => s.slug === g);
  if (fromSub?.name) return fromSub.name;
  if (fromSub) return formatDisplayTitle(String(fromSub.slug).replace(/-/g, ' '));
  const fromTyp = (categoryMeta?.types || []).find((t) => t.slug === g);
  if (fromTyp?.name) return fromTyp.name;
  if (fromTyp) return formatDisplayTitle(String(fromTyp.slug).replace(/-/g, ' '));
  return formatDisplayTitle(g.replace(/-/g, ' '));
}

/** Collection list URL (legacy / search fallback). */
export function shopPathForProduct(p) {
  const cat = String(p.category || '').trim();
  return shopGroupPath(cat, productGroupKey(p));
}
